import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import useToggle from 'hooks/useToggle'
import { last, take } from 'lib/array/arrayUtils'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import TextLink from 'LuxKit/TextLink'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

export interface MerchandiseBreadcrumb {
  label: string
  to?: string
}

interface Props {
  breadcrumbs: Array<MerchandiseBreadcrumb>
  loading?: boolean
  alwaysExpand?: boolean
}

const BreadcrumbWrapper = styled(Sheet)`
  padding: ${rem(20)} 0 0 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} 0;
  }
`

function MerchandiseBreadcrumbsSection(props: Props) {
  const { breadcrumbs, loading, alwaysExpand } = props
  const [expanded,, setExpanded] = useToggle(alwaysExpand)

  const lastBreadcrumb = last(breadcrumbs)

  return <BreadcrumbWrapper>
    <HorizontalContainerWithFadedOverflow gap={8} verticalAlign="center">
      <TextLink weight="regular" size="caption" to="/shop" wrap="no-wrap">Home</TextLink>
      <LineAngleRightIcon size="XS" />
      {loading && <TextLoadingBox typography="caption-medium" width="10ch" />}
      {!loading && <>
        {breadcrumbs.length > 2 && !expanded && <CSSBreakpoint max="mobile">
          <TextLink weight="regular" size="caption" onClick={setExpanded}>...</TextLink>
        </CSSBreakpoint>}
        {take(breadcrumbs, breadcrumbs.length - 1).map((crumb) => <CSSBreakpoint
          min={expanded ? 'mobile' : 'tablet'}
          key={crumb.label}
          as={Group}
          direction="horizontal"
          gap={8}
          verticalAlign="center"
        >
          <TextLink underline={!!crumb.to} weight="regular" size="caption" to={crumb.to} wrap="no-wrap">
            {crumb.label}
          </TextLink>
          <LineAngleRightIcon size="XS" />
        </CSSBreakpoint>)}
        {lastBreadcrumb && <>
          {!expanded && breadcrumbs.length > 1 && <CSSBreakpoint as={LineAngleRightIcon} size="XS" max="mobile" />}
          <TextLink underline={!!lastBreadcrumb.to} weight="regular" size="caption" to={lastBreadcrumb.to} wrap="no-wrap">
            {lastBreadcrumb.label}
          </TextLink>
        </>}
      </>}
    </HorizontalContainerWithFadedOverflow>
  </BreadcrumbWrapper>
}

export default React.memo(MerchandiseBreadcrumbsSection)
